import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LoadingScreen } from "./ui";

export function ProtectedRoute() {
  const { session, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  return session ? <Outlet /> : <Navigate to="/login" replace />;
}
